import React, { useEffect, useState } from 'react';
import './index.scss';
import { Button, Modal, Col, Row, Table, Typography, notification, Space, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import { DATE_FORMAT_LONG } from 'shared/constants/AppConstants';
import { LockFilled, UnlockFilled } from '@ant-design/icons';
import { AuthConsumer } from 'shared/contexts/AuthContext';

// import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"


interface Props {
    location: any;
    courseId?: any;
    hideHeader?: boolean;
}

const { Title, Text } = Typography;
const { confirm } = Modal;
export default function ReviewsPage(props: Props) {
    const { t } = useTranslation();
    const history: any = useHistory();

    const [items, setItems] = useState([] as any[]);
    const [fetching, setFetching] = useState(false);
    const [lang, setLang] = useState('' as any);
    const columns = [
        {
            title: t('genDict.review'),
            key: 'review',
            dataIndex: 'review',
        },
        {
            title: t('genDict.title'),
            key: 'title',
            dataIndex: ['course', 'title'],
        },
        {
            title: t('genDict.rating'),
            key: 'rating',
            dataIndex: 'rating',
            render: (a: number) => <Text>{a} / 5</Text>,
        },
        {
            title: t('genDict.user'),
            key: 'user',
            dataIndex: ['user', 'name'],
        },
        {
            title: t('genDict.createdAt'),
            key: 'created_at',
            dataIndex: 'created_at',
            render: (a: number) => moment(a).format(DATE_FORMAT_LONG),
        },
        {
            title: t('genDict.action'),
            key: 'action',
            render: (a: any) => {
                return <Space>
                    {
                        a.status === 'INACTIVE' ? <Button shape={'circle'} className={'success-button '} type={'primary'}  onClick={() => {
                                API_SERVICE.activateReview(a.id).then(() => {
                                    refreshItems();
                                }).catch((e) => {
                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                });
                            }
                            } icon={<UnlockFilled/>}/> :
                            <Button shape={'circle'}  type={'primary'} onClick={() => {
                                API_SERVICE.deactivateReview(a.id).then(() => {
                                    refreshItems();
                                }).catch((e) => {
                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                });
                            }
                            } danger icon={<LockFilled/>}/>
                    }
                </Space>;
            },
        },
    ];
    const refreshItems = async () => {
        try {
            setFetching(true);
            const obj: any = { order_by: 'id', page: 1, order: 'DESC' };
            if (props.courseId) {
                obj['course_id'] = props.courseId;
            }
            const {
                data: {
                    data: {
                        count,
                        current_page,
                        items,
                        per_page,
                        total,
                    },
                },
            } = await API_SERVICE.fetchReviewsAdmin(obj);
            setItems(items);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#reviewList').DataTable({
                    "language": {
                        "search": t('genDict.dataTableSearch'),
                      //   "emptyTable": "No data available in table"
                        "emptyTable": t('genDict.emptyTable'),
                        "lengthMenu": t('genDict.Show') + " _MENU_ " + t('genDict.entries'),
                          
                        "paginate": {
                          "first":      t('genDict.first'),
                          "last":       t('genDict.last'),
                          "next":      t('genDict.next'),
                          "previous":   t('genDict.previous'),
                        },
                        "info": t('genDict.Showing') + " _START_ to _END_ of _TOTAL_ " + t('genDict.entries'),
                        "infoEmpty": t('genDict.infoEmpty'),
                      }
                });
                // } ,1000);
            });
        } catch (e) {
            notification.error({
                message: t(API_SERVICE.handleErrors(e)),
            });
        } finally {
            setFetching(false);
        }
    };
    useEffect(() => {
        refreshItems();
        setLang(localStorage.getItem("language"))
    }, []);
    if(fetching){
        return <Skeleton active={true} />
    }
    return (
        <AuthConsumer>
            {({ isAuth }) =>
                !isAuth ? (
                    history.push('/login')
                ) : (
                <div className={props.hideHeader ? '' : 'list-page-wrapper'}>
                    <div className='bg-white p-3 br-5px'>
                    <div className={lang == 'ar' ? '' : 'mr-2'}>
                        <Title className={lang == 'ar' ? 'text-right' : 'mr-2'} level={3}>{t('genDict.reviews')}</Title>
                    </div>
                        <div className="table-responsive table-br-5 box-shadow mt-3">
                            <table id='reviewList' className="table table-meetings">
                                <thead>
                                    <tr>
                                    <th className="text-uppercase">{t('genDict.review')}</th>
                                    <th className="text-uppercase">{t('genDict.CourseName')}</th>
                                    <th className="text-uppercase text-center">{t('genDict.Instructor')}</th>
                                    <th className='text-uppercase text-center'>{t('genDict.rating')}</th>
                                    <th className='text-uppercase text-center'>{t('genDict.StudentName')}</th>
                                    <th className="text-uppercase">{t('genDict.ReviewDate')}</th>
                                    <th className='text-uppercase'>{t('genDict.action')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        items && items.map(item => {
                                            console.log(item)
                                        return <tr>
                                                <td>{item?.review}</td>
                                                <td>{item?.course?.title}</td>
                                                <td className='text-center'>{item?.course?.author?.name}</td>
                                                <td className="text-secondary text-center">{item?.rating}/5</td>
                                                <td className="text-secondary text-center">{item?.user?.name}</td>
                                                <td className="text-secondary">{moment(item?.created_at).format('DD MMMM, YYYY')}</td>
                                                <td>
                                                <Space>
                                                    {
                                                        item.status === 'INACTIVE' ? <Button shape={'circle'}  onClick={() => {
                                                                API_SERVICE.activateReview(item.id).then(() => {
                                                                    refreshItems();
                                                                }).catch((e) => {
                                                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                });
                                                            }
                                                            } className="btn-danger" icon={<LockFilled/>}/> :
                                                            <Button shape={'circle'} className={'success-button '} type={'primary'} onClick={() => {
                                                                API_SERVICE.deactivateReview(item.id).then(() => {
                                                                    refreshItems();
                                                                }).catch((e) => {
                                                                    notification.error({ message: API_SERVICE.handleErrors(e) });
                                                                });
                                                            }
                                                            } icon={<UnlockFilled/>}/>
                                                    }
                                                </Space>
                                                </td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {/* <Row gutter={20} justify={'space-between'}>
                        <Col flex={'auto'}>
                            <Title level={3}>{t('genDict.reviews')}</Title>
                        </Col>
                    </Row>
                    <Table loading={fetching} scroll={{ x: true }} pagination={{
                        pageSize: 100,
                        hideOnSinglePage: true,
                    }} dataSource={items} columns={columns}/> */}
                </div>
                )
            }
        </AuthConsumer>
    );
}
